import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { CiEdit } from 'react-icons/ci';

// MUI Imports
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import dayjs from 'dayjs';

const RescheduleStreamingModal = ({ courseID, date, setTopicsLoading, setRescheduleSessionModal }) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [isPickerOpen, setIsPickerOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false); // ✅ Added loading state

    useEffect(() => {
        if (date) {
            // ✅ Works perfectly if 'date' is "2026-01-12T05:30:00.000Z"
            // Dayjs automatically converts this UTC string to the User's Local Time
            setSelectedDate(dayjs(date));
        }
    }, [date]);

    const handleReschedule = async () => {
        try {
            if (!selectedDate) {
                toast.error("Please select a date and time");
                return;
            }

            setIsSubmitting(true); // Disable button

            // ✅ Logic is CORRECT: Converts Local Time -> UTC String
            const formattedDate = selectedDate.toISOString();

            console.log("Reschedule Payload:", { broadcastId: courseID, newDate: formattedDate });

            await axios.post(`${BACKEND_SERVER_URL}/reschedule-stream`, {
                broadcastId: courseID,
                newDate: formattedDate
            });

            toast.success('Session rescheduled successfully');
            setTopicsLoading(prev => !prev); // Refresh parent table
            setRescheduleSessionModal(false); // Close modal

        } catch (error) {
            console.error(error);
            const msg = error?.response?.data?.message || error?.response?.data; // Handle object or string response

            if (typeof msg === 'string' && msg.includes('greater than current date')) {
                toast.error("New Time should be greater than current time");
            } else {
                toast.error("Failed to reschedule session");
            }
        } finally {
            setIsSubmitting(false); // Re-enable button
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>

            <div className="modal d-block" tabIndex="-1" style={{ zIndex: 1051 }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content shadow-lg border-0 me-2 rounded-3">
                        {/* Header */}
                        <div className="modal-header bg-dark text-white">
                            <h5 className="modal-title text-white d-flex align-items-center justify-content-center">
                                <i className="bi bi-calendar-event me-2"></i>
                                Reschedule Streaming
                            </h5>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                onClick={() => setRescheduleSessionModal(false)}
                            ></button>
                        </div>

                        {/* Body */}
                        <div className="modal-body p-4">
                            <div className="text-center mb-4">
                                <div className="badge bg-light text-dark border p-2 mb-2">
                                    Stream ID: {courseID}
                                </div>
                                <p className="text-muted small fs-4 text-black">Select the new date and time for this session</p>
                            </div>

                            <div className="form-group">
                                <label className="form-label fw-bold text-danger">NEW DATE & TIME</label>
                                <div className="input-group position-relative">

                                    {/* 1. Custom UI Box */}
                                    <div
                                        style={{ padding: "10px", fontSize: "14px", cursor: 'pointer' }}
                                        className="d-flex align-items-center justify-content-between w-100 border rounded"
                                        onClick={() => setIsPickerOpen(true)}
                                    >
                                        <p className="mb-0 fw-bold">
                                            {selectedDate ? selectedDate.format('DD MMM YYYY, hh:mm A') : "Select Date"}
                                        </p>
                                        <CiEdit size={20} className='ms-3 text-primary' />
                                    </div>

                                    {/* 2. Hidden MUI Picker */}
                                    <MobileDateTimePicker
                                        open={isPickerOpen}
                                        onClose={() => setIsPickerOpen(false)}
                                        onAccept={(newValue) => {
                                            setSelectedDate(newValue);
                                            setIsPickerOpen(false);
                                        }}
                                        value={selectedDate}
                                        ampm={true}
                                        slots={{ field: () => null }}
                                        slotProps={{
                                            dialog: { style: { zIndex: 1055 } }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="modal-footer bg-light border-0">
                            <button
                                type="button"
                                className="btn btn-outline-secondary text-white bg-danger px-4"
                                onClick={() => setRescheduleSessionModal(false)}
                                disabled={isSubmitting}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-dark px-4 shadow-sm"
                                onClick={handleReschedule}
                                disabled={isSubmitting} // ✅ Prevent double click
                            >
                                {isSubmitting ? 'Updating...' : 'Confirm Reschedule'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </LocalizationProvider>
    );
};

export default RescheduleStreamingModal;